import React, { useEffect } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useField, useFormikContext } from 'formik';

const FormInput = ({ label, children, InputLabelProps, icon, validateOnChange, validateOnBlur, ...props }) => {
  const [field, meta] = useField(props);
  const { validateField, setFieldTouched } = useFormikContext();

  // Handle real-time validation
  useEffect(() => {
    if (field.value && validateOnChange) {
      validateField(field.name);
    }
  }, [field.value, field.name, validateField, validateOnChange]);

  // Handle blur validation
  const handleBlur = (e) => {
    field.onBlur(e);
    if (validateOnBlur) {
      setFieldTouched(field.name, true, true);
    }
  };

  return (
    <div>
      <TextField
        fullWidth
        label={label}
        {...field}
        {...props}
        onBlur={handleBlur}
        error={meta.touched && Boolean(meta.error)}
        helperText={meta.touched && meta.error}
        InputLabelProps={{
          shrink: Boolean(field.value) || props.type === 'date',
          ...InputLabelProps
        }}
        InputProps={{
          ...(icon ? {
            endAdornment: (
              <InputAdornment position="end">
                {icon}
              </InputAdornment>
            )
          } : {}),
          ...props.InputProps
        }}
      />
      {children}
    </div>
  );
};

export default FormInput;

